/**
 * @flow
 * @relayHash 57e78d974b5cbb42a5866ec34535bcc9
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type GradeGroupsAdminQueryResponse = {|
  +master: ?{| |};
|};
*/


/*
query GradeGroupsAdminQuery {
  master {
    ...GradeGroups_master
  }
}

fragment GradeGroups_master on Master {
  allGradeGroups(first: 10) {
    edges {
      node {
        id
        name
        description
      }
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "GradeGroupsAdminQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Master",
        "name": "master",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "GradeGroups_master",
            "args": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "GradeGroupsAdminQuery",
  "query": {
    "argumentDefinitions": [],
    "kind": "Root",
    "name": "GradeGroupsAdminQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Master",
        "name": "master",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 10,
                "type": "Int"
              }
            ],
            "concreteType": "GradeGroupConnection",
            "name": "allGradeGroups",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "GradeGroupEdge",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "GradeGroup",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "description",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "allGradeGroups{\"first\":10}"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query GradeGroupsAdminQuery {\n  master {\n    ...GradeGroups_master\n  }\n}\n\nfragment GradeGroups_master on Master {\n  allGradeGroups(first: 10) {\n    edges {\n      node {\n        id\n        name\n        description\n      }\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/components/master/__generated__/GradeGroupsAdminQuery.graphql.js